/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropYouTubeVideoResponse
 */
export interface DropYouTubeVideoResponse {
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideoResponse
     */
    videoId: string;
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideoResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideoResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideoResponse
     */
    publishedAt: string;
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideoResponse
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropYouTubeVideoResponse
     */
    channelTitle: string;
    /**
     * 
     * @type {number}
     * @memberof DropYouTubeVideoResponse
     */
    durationSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof DropYouTubeVideoResponse
     */
    viewCount?: number;
}

/**
 * Check if a given object implements the DropYouTubeVideoResponse interface.
 */
export function instanceOfDropYouTubeVideoResponse(value: object): value is DropYouTubeVideoResponse {
    if (!('videoId' in value) || value['videoId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('publishedAt' in value) || value['publishedAt'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('channelTitle' in value) || value['channelTitle'] === undefined) return false;
    return true;
}

export function DropYouTubeVideoResponseFromJSON(json: any): DropYouTubeVideoResponse {
    return DropYouTubeVideoResponseFromJSONTyped(json, false);
}

export function DropYouTubeVideoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropYouTubeVideoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'videoId': json['videoId'],
        'title': json['title'],
        'description': json['description'],
        'publishedAt': json['publishedAt'],
        'thumbnailUrl': json['thumbnailUrl'],
        'channelTitle': json['channelTitle'],
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
        'viewCount': json['viewCount'] == null ? undefined : json['viewCount'],
    };
}

export function DropYouTubeVideoResponseToJSON(json: any): DropYouTubeVideoResponse {
    return DropYouTubeVideoResponseToJSONTyped(json, false);
}

export function DropYouTubeVideoResponseToJSONTyped(value?: DropYouTubeVideoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'videoId': value['videoId'],
        'title': value['title'],
        'description': value['description'],
        'publishedAt': value['publishedAt'],
        'thumbnailUrl': value['thumbnailUrl'],
        'channelTitle': value['channelTitle'],
        'durationSeconds': value['durationSeconds'],
        'viewCount': value['viewCount'],
    };
}

